import { fetchTaskCountApi } from "../../../../network/service";
import { fetchLeadIdFromURL } from "../../../../utils/helpers";
export const taskStatusMap = {
  pending: 0,
  completed: 1,
  cancelled: 2,
  overdue: 3,
};


const fetchTaskCount = async (config) => {
  const body = {
    Parameter: {
      StatusCode: taskStatusMap[config?.taskStatus] ?? -1,
      Id: fetchLeadIdFromURL(),
    },
    Sorting: {
      Direction: 0,
    },
    Paging: {
      PageIndex: 1,
      PageSize: 1,
    },
  };
  const response = await fetchTaskCountApi(body);
  if (response.status !== 200) throw new Error("Failed to fetch task count");
  return response.data?.TotalRecords;
};

export default fetchTaskCount;
